import type { MarketingAutomaticoItem } from "../../../services/marketingAutomatico"

export type { MarketingAutomaticoItem }

export type MarketingAutomaticoModel = {
    lista: MarketingAutomaticoItem[]
}

export const MarketingAutomaticoInicial: MarketingAutomaticoModel = {
    lista: [],
}
